import React from 'react'
import { NavLink } from 'react-router-dom'
import thetonight from '../image/thetonight.png'

const Varietydetails7 = () => {
  return (
    <div className="bg-gradient-to-r from-pink-200 to-fuchsia-100 overflow-hidden h-screen">
      <div>
      <NavLink to="https://www.youtube.com/watch?v=xkbqmRvRdbI"> <a class="group sm:flex rounded-xl dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-600 p-5" href="https://www.youtube.com/watch?v=xkbqmRvRdbI">
      <div class="flex-shrink-0 relative rounded-xl overflow-hidden w-full h-[200px] sm:w-[250px] sm:h-[350px]">
        <img class="w-full h-full absolute top-0 start-0 object-cover" src={thetonight} alt="Image Description"/>
      </div>

      <div class="grow">
        <div class="p-4 flex flex-col h-full sm:p-6">
          <div class="mb-3">
            <p class="inline-flex items-center gap-1.5 py-1.5 px-3 rounded-md text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-800 dark:text-gray-200">
            Variety Show
            </p>
          </div>
          <h3 class="text-lg sm:text-2xl font-semibold text-purple-600 group-hover:text-blue-600 dark:text-gray-300 dark:group-hover:text-white">
          The Tonight Show Starring Jimmy Fallon
          </h3>
          <div className='border-2 p-2 border-blue-300 hover:border-purple-400 rounded-lg mb-5 mt-3'>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Genres: </span>Variety Show
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md'>Release Date: </span>September 25, 2018
          </p>
          <p class="mt-2 text-gray-600 dark:text-gray-400">
            <span className='font-bold text-md '>Episode: </span>14
          </p>
          </div>
        </div>
      </div>
    </a> </NavLink>
    <hr class="border-purple-500 mt-5"></hr>

<div>
  <div className='flex justify-center'>
     <h1 className='font-bold text-2xl p-2 text-blue-500'>About the show</h1>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>On September 25, 2018, BTS made their first guest appearance on 'The Tonight Show Starring Jimmy Fallon' where they performed their hit song 'Idol' to a live studio audience. BTS made several more appearances on the show since their debut both in person and virtually. Jimmy Fallon would go on to dedicate a full week of shows to the group where they made an appearance every night during COVID-19. </p>
  </div>
  <div className='p-5 text-lg font-semibold text-gray-500'>
      <p>The Tonight Show Starring Jimmy Fallon' features hilarious highlights from the show including: comedy sketches, music parodies, celebrity interviews, ridiculous games, and, of course, Jimmy's Thank You Notes and hashtags! </p>
  </div>
  <div className='text-2xl font-bold text-blue-500 p-4'>
  APPEARANCES DATE
  </div>
  <div className='text-purple-500 text-xl font-semibold p-1 ml-7'>
      <p>September 25, 2018:    Fortnite Dance Challenge / Interview & 'Idol' & 'I'm Fine' performance</p>
<p>February 24, 2020:       First Impressions / Secret Career Dreams / Subway Olympics / Katz's Delicatessen / 'ON' performance at Grand Central Station</p>
<p>September 28, 2020:    'Dynamite' performance feat. Jimmy Fallon & The Roots & 'Idol' performance </p>
<p>September 29, 2020:    'Home' Performance </p>
<p>September 30, 2020:    What they were like in High School & 'Black Swan' performance </p>
<p>October 1, 2020:           Tonight Show Zoom Olympics & 'Mikrokosmos' performance</p>
<p>July 23, 2021:               Tonight Show Will It Fit?</p>
<p>May 1, 2023:                 SUGA Solo Appearance & Performance</p>
<p>November 6, 2023        Jung Kook Solo Appearance & Performance</p>
  </div>
</div>
      </div>
    </div>
  )
}

export default Varietydetails7
